<script>
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import contentParserMixin from '@/views/content-parser-mixin';

export default {
	name: 'HomePage',
	mixins: [contentDataLoaderMixin, contentParserMixin],
	data() {
		return {
			pid: 1,
			contentType: 'pages',
			containerClass: 'home-page-container',
			contentClass: 'home-page-content',
		};
	},
	created() {
		this.$root.$emit('resetCoverImages');
	},

};
</script>

<style src="#/styles/views/HomePage/HomePage.less" lang="less" scoped></style>
